import axiosInstance from '../components/api/axiosInstance';

/**
 * Context Analytics Service
 * Routes through admin-service proxy (/api/context-analytics)
 * which adds JWT auth + businessId before forwarding to context-service
 */

const BASE = '/api/context-analytics';

const contextAnalyticsService = {
  /**
   * Get agent activity with optional filters
   */
  getAgentActivity: async (filters = {}) => {
    const params = {
      limit: filters.limit || 100,
      skip: filters.skip || 0,
      ...filters
    };
    const response = await axiosInstance.get(`${BASE}/agents/activity`, { params });
    return response.data;
  },

  /**
   * Get context queries for a specific agent
   */
  getAgentContextQueries: async (agentId, filters = {}) => {
    const params = {
      limit: filters.limit || 50,
      ...filters
    };
    const response = await axiosInstance.get(`${BASE}/agents/${agentId}/context-queries`, { params });
    return response.data;
  },

  /**
   * Get agent context usage statistics
   */
  getAgentContextUsage: async (filters = {}) => {
    const response = await axiosInstance.get(`${BASE}/agents/context-usage`, { params: filters });
    return response.data;
  },

  /**
   * Get RAG statistics
   */
  getRAGStatistics: async () => {
    const response = await axiosInstance.get(`${BASE}/rag/statistics`);
    return response.data;
  },

  /**
   * Get vector store usage by department
   */
  getVectorStoreUsage: async () => {
    const response = await axiosInstance.get(`${BASE}/vector-store/usage`);
    return response.data;
  },

  /**
   * Get recently indexed documents
   */
  getRecentIndexes: async (limit = 20) => {
    const response = await axiosInstance.get(`${BASE}/knowledge/recent-indexes`, {
      params: { limit }
    });
    return response.data;
  },

  /**
   * Get knowledge indexing status
   */
  getKnowledgeIndexingStatus: async () => {
    const response = await axiosInstance.get(`${BASE}/knowledge/status`);
    return response.data;
  },

  /**
   * Get cache statistics
   */
  getCacheStatistics: async (filters = {}) => {
    const response = await axiosInstance.get(`${BASE}/cache/statistics`, { params: filters });
    return response.data;
  },

  /**
   * Get top cached queries
   */
  getTopCachedQueries: async (limit = 10) => {
    const response = await axiosInstance.get(`${BASE}/cache/top-queries`, {
      params: { limit }
    });
    return response.data;
  },

  /**
   * Invalidate cache for a specific identifier
   */
  invalidateCache: async (identifier) => {
    const response = await axiosInstance.delete(`${BASE}/cache/invalidate/${identifier}`);
    return response.data;
  },

  /**
   * Get interaction timeline
   */
  getInteractionTimeline: async (filters = {}) => {
    const params = {
      limit: filters.limit || 50,
      ...filters
    };
    const response = await axiosInstance.get(`${BASE}/interactions/timeline`, { params });
    return response.data;
  },

  /**
   * Get interactions summary
   */
  getInteractionsSummary: async (filters = {}) => {
    const response = await axiosInstance.get(`${BASE}/interactions/summary`, { params: filters });
    return response.data;
  },

  /**
   * Get performance overview
   */
  getPerformanceOverview: async (filters = {}) => {
    const response = await axiosInstance.get(`${BASE}/performance/overview`, { params: filters });
    return response.data;
  },

  /**
   * Retry indexing for a knowledge document
   */
  retryIndexing: async (knowledgeId) => {
    const response = await axiosInstance.post(`${BASE}/knowledge/${knowledgeId}/reindex`);
    return response.data;
  }
};

export default contextAnalyticsService;
